//Background colors
const fontSize = {
  small: '0.625rem',
  caption: '0.75rem',
  note: '0.875rem',
  body: '1rem',
  subheader: '1.25rem',
  title: '1.5rem',
  headline: '2rem',
  display: '2.5rem',
  jumbo: '3rem',
}

const lineHeight = {
  body: '1.5',
  heading: '1.125',
}

const fontUnits = {
  fontSize,
  lineHeight,
}

export default fontUnits



// WEBPACK FOOTER //
// ./src/global/fontSize.js